<div class="col-12">
  <app-mi-grid-v2 [uniqId]="uniqId" [url]="url" [columnDefs]="columns" rowSelection="multiple" [overflowShow]="true"
    divClass="mi-grid"></app-mi-grid-v2>
</div>
